var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNavigation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_-_navigation",
    "data-name": "icon - navigation",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_241",
    "data-name": "Rectangle 241",
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2366",
    "data-name": "Path 2366",
    d: "M8.643.425l7.325,16.98a.7.7,0,0,1-1.071.84l-6.47-4.882a.7.7,0,0,0-.843,0L1.126,18.14A.7.7,0,0,1,.061,17.3L7.35.425a.7.7,0,0,1,1.293,0",
    transform: "translate(5 4)",
    fill: "#999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavigation);
export default __webpack_public_path__ + "static/media/icon-navigation.578f7bc0fbcabdbbe436cc2cda0e5a6b.svg";
export { ForwardRef as ReactComponent };